const referrer = 'https://www.amio-ads.ru/'
export function setReferrer(){
  if(document.referrer == referrer){
    window.sessionStorage.setItem('referrer', document.referrer)
  }
}

export function isReferrer(){
  return window.sessionStorage.getItem('referrer') == referrer
}